import axios from "axios";
import { updateCifsShareExpiration } from "../../helpers/expiration-handler";
import { initEditMountExpireModal } from "../helpers/local-shares-helper";

const initViewLocalSharePathLink = () => {
  document.querySelectorAll('.js-view-local-share-path').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const currentElement = e.currentTarget;
      if (currentElement.classList.contains('disabled')) {
        return;
      }
      currentElement.classList.add('disabled');

      const originalText = currentElement.textContent;
      currentElement.textContent = currentElement.dataset.busyText;

      const shareId = currentElement.dataset.shareId;

      axios.get(`/share/display_cifs_share_path/${shareId}`)
        .then(response => {
          const body = `For Windows:</br>${response.data.dialogMsg}</br></br>For Mac:</br> ${response.data.smbPath}`;
          show_info(response.data.dialogTitle, response.data.dialogHeader, body);

          if (response.data.ok) {
            currentElement.textContent = originalText;
            currentElement.classList.remove('disabled')
          } else {
            currentElement.textContent = currentElement.dataset.errorText;
          }
        })
    })
  })
};

const initUnmountLocalShareLink = (localSharesDialogData) => {
  document.querySelectorAll('.js-cifs_supress').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      const currentElement = e.currentTarget;
      if (currentElement.classList.contains('disabled')) {
        return;
      }
      currentElement.classList.add('disabled');
      currentElement.textContent = currentElement.dataset.busyText;

      const shareId = currentElement.dataset.shareId;
      axios.get(`/share/suppress_cifs_share/${shareId}`)
        .then(response => {
          show_alert_2(response.data.dialogTitle, response.data.dialogMsg);
          if (response.data.ok) {
            const parentRow = currentElement.closest('tr');
            if (parentRow && parentRow.parentElement.children.length > 1) {
              parentRow.remove();
            } else {
              loadResellerLocalSharesActivities(localSharesDialogData)
            }
          } else {
            currentElement.textContent = currentElement.dataset.errorText;
          }
        })
    })
  })
};

const initUpdateMountExpireTimeLink = () => {
  document.querySelectorAll('.js-edit-local-share-mount-expire-time').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      const currentElement = e.currentTarget;
      const shareId = currentElement.dataset.shareId;

      axios.get(`/share/load_edit_expire_dialog/${shareId}`, {responseType: 'text'})
        .then(response => {
          const contentContainer = document.getElementById('content');
          document.getElementById('content').insertAdjacentHTML('beforeend', response.data);
          initEditMountExpireModal();
        })
        .catch(() => {
          show_alert(_error_label, err_operation_failed);
        })
    })
  })
};

const loadResellerLocalSharesActivities = (localSharesDialogData) => {
  axios.get(`/reseller/get_reseller_exposed_local_shares/${localSharesDialogData.resellerId}`)
    .then(response => {
    showLocalSharesActivities(response, localSharesDialogData);
    updateCifsShareExpiration();
  });
};

const showLocalSharesActivities = (response, localSharesDialogData) => {
  const currentLocalShares = document.querySelector(`.feed-table-interest .local_shares`);
  if (currentLocalShares) {
    currentLocalShares.remove();
  }

  const nothingRecent = document.querySelector(`.feed-table-interest .nothingrecent`);
  if (nothingRecent) {
    nothingRecent.remove();
  }

  const activitiesTable = document.querySelector(`.feed-table-interest`);
  if (!activitiesTable) {
    return;
  }

  if (response.data.local_shares.length > 0) {
    const localSharesActivitiesHtml = Handlebars.compile(atob(localSharesDialogData.resellerLocalSharesActivitiesTemplate))({
      shares: response.data.local_shares,
    })
    activitiesTable.insertAdjacentHTML('afterbegin', localSharesActivitiesHtml);
  }

  const activities = activitiesTable.querySelectorAll(`.feed-table-interest .feed-row`);
  if (activities.length > 0) {
    const activitiesHeader = document.querySelector(`.collapsible-feed .header.pointer`);
    if (activitiesHeader) {
      activitiesHeader.classList.add('expanded');
    }

    activitiesTable.style.display = '';
  }

  initViewLocalSharePathLink();
  initUnmountLocalShareLink(localSharesDialogData);
  initUpdateMountExpireTimeLink();
};

export { loadResellerLocalSharesActivities };
